import logoRu from './assets/logo_ru.svg';
import logoEn from './assets/logo_en.svg';
import disneyLogo from '../../styles/theme/disney/PJ_PizzaPlanet_Logo.svg';
import mothersDayLogo from '../../styles/theme/mothersDay/mama_johns_logo.svg';
import {
  CITY_THEME_DISNEY,
  CITY_THEME_MOTHERS_DAY,
  getVisualActiveCityTheme,
} from '../../utils/cityTheme';

export const logos = {
  ru: logoRu,
  en: logoEn,
  pl: logoEn,
};

export function getHeaderLogoSrc(lang, userCity) {
  const theme = getVisualActiveCityTheme(userCity);

  if (theme === CITY_THEME_DISNEY) {
    return disneyLogo;
  }

  if (theme === CITY_THEME_MOTHERS_DAY) {
    return mothersDayLogo;
  }

  return logos[lang] || logos.en;
}
